import { turnIntoButton } from "../../functions";
import * as errors from "../errors";
import { inputRangeMin, inputRangeMax } from "./range-input";

export function validate(data, submitter) {
    const isByParts = data["price-type"] === "by-parts";

    if (isByParts) {
        if (!validateBank(data) || !validatePeriod(data)) throwError();
    }

    if (!validateContactData(data)) throwError();

    function throwError() {
        errors.createError("Заполни все шаги, чтобы перейти дальше к оплате");
        turnIntoButton(submitter);
        throw new Error();
    }
}
function validateBank(data) {
    if (data.bank === "tinkoff" || data.bank === "sber") return true;
    return false;
}
function validatePeriod(data) {
    const isNum = Number.isInteger(+data.period);
    const isValidNum =
        +data.period >= inputRangeMin && +data.period <= inputRangeMax;
    if (isNum && isValidNum) return true;
    return false;
}
function validateProvider(data) {
    if (data.provider === "tinkoff" || isUkassaProvider(data)) return true;
    return false;
}
function validatePaymentType(data) {
    if (
        data["payment-type"] === "bank_card" ||
        data["payment-type"] === "yoo_money" ||
        data["payment-type"] === "sbp" ||
        data["payment-type"] === "sberbank" ||
        data["payment-type"] === "qiwi" ||
        data["payment-type"] === "tinkoff_bank"
    )
        return true;
    return false;
}
function validateContactData(data) {
    if (
        data["name"] &&
        data["email"] &&
        data["telegram"] &&
        data["telegram"].startsWith("@")
    )
        return true;

    return false;
}
function isUkassaProvider(data) {
    if (data.provider === "ukassa") return true;
    return false;
}
